import React from "react";

export default ({ width = 16, height = 15, fill = "#18A0FB", ...props }) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00132 0.666016C8.25507 0.666016 8.48681 0.810064 8.59913 1.0376L10.5042 4.89699L14.7644 5.51969C15.0154 5.55639 15.2239 5.73239 15.3022 5.97373C15.3804 6.21507 15.3149 6.4799 15.1331 6.65692L12.051 9.65893L12.7784 13.9C12.8213 14.1501 12.7185 14.4029 12.5131 14.5521C12.3078 14.7012 12.0356 14.7209 11.811 14.6027L8.00132 12.5992L4.19162 14.6027C3.96701 14.7209 3.69482 14.7012 3.4895 14.5521C3.28418 14.4029 3.18135 14.1501 3.22425 13.9L3.95164 9.65893L0.8695 6.65692C0.687754 6.4799 0.622239 6.21507 0.700491 5.97373C0.778743 5.73239 0.987196 5.55639 1.23824 5.51969L5.49848 4.89699L7.40352 1.0376C7.51583 0.810064 7.74758 0.666016 8.00132 0.666016Z"
        fill="white"
      />
    </svg>
  );
};
